import { Box, Chip, Paper, Typography } from '@mui/material';
import React from 'react';
import ReactGA from 'react-ga4';
import MapIcon from '@mui/icons-material/Map';
import TimelineIcon from '@mui/icons-material/Timeline';
import NoteIcon from '@mui/icons-material/Note';
import { LandingDemo, requestLandingDemoImport } from '../hooks/useOnboardingFlow';
import { localStorageSetIsIntroDialogCompleted } from '../localStorage';
import { useCookieConsent } from '../contexts/CookieConsentContext';

const SUGGESTIONS: { label: string; icon: React.ReactElement; demo: LandingDemo; analyticsAction: string }[] = [
	{ label: 'Plan a product roadmap', icon: <MapIcon />, demo: 'roadmap', analyticsAction: 'WelcomeRoadmapPlanningClicked' },
	{ label: 'Track team performance', icon: <TimelineIcon />, demo: 'engineering', analyticsAction: 'WelcomeTeamPerformanceClicked' },
	{ label: 'Keep a daily journal', icon: <NoteIcon />, demo: 'journal', analyticsAction: 'WelcomeJournalingClicked' },
];

export const WelcomeBlock = () => (
	<Paper sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, textAlign: 'center' }}>
		<Typography variant='h5'>Let&apos;s get started.</Typography>
		<Typography variant='body2' color='text.secondary'>
			Untwyn helps you keep notes and build systems for tracking whatever data matters in your work, in a structured and comfortable way.
		</Typography>
		<Typography variant='body2' color='text.secondary'>
			Let&apos;s set up a custom workspace around the data that&apos;s relevant to your work.
		</Typography>
	</Paper>
);

export const DemoPresetsBlock = () => {
	const { analyticsConsent } = useCookieConsent();

	const handleSuggestionClick = (demo: LandingDemo, analyticsAction: string) => {
		localStorageSetIsIntroDialogCompleted(true);
		requestLandingDemoImport(demo);
		if (analyticsConsent) {
			ReactGA.event({
				category: 'UI',
				action: analyticsAction,
			});
		}
	};

	return (
		<Paper sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, textAlign: 'center' }}>
			<Typography variant='body2' color='text.secondary'>
				Alternatively, if you feel like exploring on your own, you can pick a demo preset below to get a feel of how other people use Untwyn.
			</Typography>
			<Box display='flex' flexWrap='wrap' justifyContent='center' gap={1}>
				{SUGGESTIONS.map(({ label, icon, demo, analyticsAction }) => (
					<Chip
						key={demo}
						icon={icon}
						label={label}
						variant='outlined'
						clickable
						onClick={() => handleSuggestionClick(demo, analyticsAction)}
					/>
				))}
			</Box>
		</Paper>
	);
};
